import React, { useState } from 'react';
import { Link } from 'react-router';
import './login.scss';

import TelInput from '../Form/TelInput/TelInput';
import Button from '../Form/Button/Button';
import { LoadingButton } from '../Form/Button/Button';
import chevLeft from '../../assets/images/chev-left-royal.svg';
import { useMutation } from '@apollo/react-hooks';
import { gql } from 'apollo-boost';
import VerifyOtp from './VerifyOtp';
import { useFeatureFlags } from '../FeatureFlags/withFeatureFlags';
import bottomLeftCornerImg from "../../assets/images/Stripes Light Bottom Left.svg"
import TopRightCornerImg from "../../assets/images/Stripes Light Top Right.svg"
import CommonContainerStrips from "./CommonContainerStrips";
/** @import { ForgotEmailProps } from './ForgotEmailTypes' */

const SEND_FORGOT_EMAIL_OTP = gql`
    mutation SendForgotEmailOtp($request : SendForgotEmailOtpType!){
      sendForgotEmailOtp(request:$request) {
        success
        verificationToken
      }
    }  
  `;

const SEND_SHOWN_EMAIL_NOTIFICATION = gql`
    mutation emailShownNotifyUser($request : EmailShownNotifyUserRequestType!){
      emailShownNotifyUser(request:$request) {
        success
      }
    }  
  `;

function ForgotEmail(/** @type {ForgotEmailProps} */ _props) {
  const [step, setStep] = useState(1);
  const [mobileNumber, setMobileNumber] = useState('');
  const [email, setEmail] = useState('');
  const [multipleEmails, setMultipleEmails] = useState(false);

  const [stepOneLoading, setStepOneLoading] = useState(false);
  const [stepOneError, setStepOneError] = useState(false);
  const [verificationToken, setVerificationToken] = useState('');

  const [sendForgotEmailOtp] = useMutation(SEND_FORGOT_EMAIL_OTP);
  const [emailShownNotify] = useMutation(SEND_SHOWN_EMAIL_NOTIFICATION);

  const handleMobileChange = (/** @type {string} */ mobileNumber) => {
    setStepOneError(false);
    setMobileNumber(mobileNumber);
  };

  const stepOneClick = async (/** @type {React.MouseEvent<HTMLLabelElement, MouseEvent>} */ evt) => {
    evt.preventDefault();
    try {
      setStepOneLoading(true);

      const result = await sendForgotEmailOtp({
        variables: {
          request: {
            mobileNumber: mobileNumber
          }
        }
      });

      setStepOneLoading(false);

      if (result.data.sendForgotEmailOtp.success) {
        setVerificationToken(result.data.sendForgotEmailOtp.verificationToken);
        setStep(2);
      }
      else {
        setStepOneError(true);
      }
    }
    catch {
      setStepOneLoading(false);
      setStepOneError(true);
    }
  };

  const enableStepOneNext = () => {
    return mobileNumber && mobileNumber.length == 13;
  };

  const renderNextButton = (/** @type {string} */ label, /** @type {boolean} */ isLoading, /** @type {boolean | undefined} */ disabled, /** @type {(() => void) | undefined} */ callback) => {
    return isLoading ?
      <LoadingButton customClassNames={['loginButton', 'button--primary']} /> :
      <Button customClassNames={['loginButton', 'button--primary']} disabled={disabled} label={label} onClick={callback} />
  };

  const renderStepOne = () => {
    return (
      <form>
        <div className="login__line">
          Please enter the mobile number related to your account.
        </div>
        <label className="loginP3__lblMobileNumber">Your mobile number</label>
        <TelInput
          className="login__input"
          onChange={handleMobileChange}
          name={'mobile'}
          placeholder='Mobile Number'
          disabled={false}
          prependValue='+44'
          pattern='^\+\d*'
          maxLength={13}
          value={mobileNumber}
        />
        <div className={stepOneError ? "login__error" : "login__error login__error--hide"}>
          <span className="login__error--wrap">Looks like you have entered the wrong information, please try again</span>
        </div>

        {renderNextButton("Next", stepOneLoading, !enableStepOneNext(), stepOneClick)}
      </form>
    );
  };

  const otpVerifiedSuccess = (/** @type {string} */ email, /** @type {any} */ multipleEmails) => {
    setEmail(email);
    setMultipleEmails(multipleEmails);

    emailShownNotify({
      variables: {
        request: {
          verificationToken: verificationToken
        }
      }
    });

    setStep(3);
  };

  const renderStepTwo = () => {
    return <VerifyOtp mobileNumber={mobileNumber} verificationToken={verificationToken} onSuccess={otpVerifiedSuccess} />
  };

  const stepThreeClick = (/** @type {React.MouseEvent<HTMLLabelElement, MouseEvent>} */ e) => {
    e.preventDefault();
    window.location.href = '/login';
  };

  const renderStepThree = () => {
    return (
      <form>
        <div className="login__line login__margin">
          Your email address is <strong className="login__navy">{email}</strong>. If you need to, you can update your email address once you’ve logged in. Simply select ‘my profile’ from the menu.
        </div>
        <Button onClick={stepThreeClick} customClassNames={['login__button']} label="Go to login" />
      </form>
    );
  };

  const renderStep = () => {
    switch (step) {
      default: return renderStepOne();
      case 2: return renderStepTwo();
      case 3: return renderStepThree();
    }
  };

  const [isTabletOrAbove, setIsTabletOrAbove] = useState(window.innerWidth >= 768);

  return (
    <>
      <CommonContainerStrips propData={
        {
          bottomLeftImg: bottomLeftCornerImg, topRightImg: TopRightCornerImg, children: 
          (
            <div className="troubleLoggingIn__frame3423">
              <div className="troubleLoggingIn__login2">
                <Link to="/login" className="login__link login__link--back loginP3__backButton"><img
                  src={chevLeft} />Back
                  to login</Link>
                <h1 className="loginP3__title" style={{ width: 'auto' }}>Forgot your email?</h1>
                {renderStep()}
              </div>
            </div>
          )
        }} 
      />
    </>
  );
};


export default ForgotEmail;
